import { Box } from "./Box"
import { BoxProps } from "./types"

export const Grid = ({children, gap = '8px', columns = '1fr', ...props}:BoxProps) => {
    return <Box className="d-grid" gap={gap} columns={columns} {...props}>
        {children}
    </Box>
}